module.exports = __webpack_public_path__ + "img/bannerN5.aeae44c7.png";